export class JobRequest {
    constructor(json) {
        this.id = json.id;
        this.maxExecutions = json.max_executions;
        this.isRepeatTrip = json.is_repeat_trip;
        this.jobIds = json.job_ids;
        this.primaryJobId = json.primary_job_id;
    }
}
//# sourceMappingURL=JobRequest.js.map